const newVoicePickerMenu = [
    {
        icon: "backup_icon",
        key: "backuprecordingfile",
        name: "Voice Picker",
        url: "home/app/configurations/new-voice-picker",
        description:
          "Backup and Download ",
        productionReady: true,
        disabled: false,
      },
  ];
  
  export { newVoicePickerMenu };
  